<template>
  <div class="SwitchBackground">
    <sidebar></sidebar>

    <div class="backgroundImg">
      <img :class="{ display_image: !BusinessSingleRoom_switch }" class :src="textupdate.photos[0]" />
      <img :class="{ display_image: !HoneymoonDoubleRoom_switch }" class :src="textupdate.photos[1]" />
      <img :class="{ display_image: !DukeDoubleRoom_switch }" class :src="textupdate.photos[2]" />
      <img :class="{ display_image: !CozydoubleRoom_switch }" class :src="textupdate.photos[3]" />
      <img :class="{ display_image: !DeluxeQuadrupleRoom_switch }" class :src="textupdate.photos[4]" />
      <img :class="{ display_image: !VIPQuadrupleRoom_switch }" class :src="textupdate.photos[5]" />
    </div>

    <!-- For PC -->
    <div class="Room_Change_Option">
      <div class="AllStyle business">
        <h3 class="Room" :class="{ 'Click-Up': isAddClass }" @click="Bus2">
          <a href="#">商務單人房</a>
        </h3>
        <h3 v-show="!BusinessSingleRoom_switch">
          <router-link target="_blank" :to="{ name: 'BusinessRoom' }">{{ Room_introduction }}</router-link>
        </h3>
      </div>

      <div class="AllStyle dense">
        <h3 class="Room" :class="{ 'Click-Up': isDenseAddClass }" @click="Bus2">
          <a href="#">蜜月雙人房</a>
        </h3>
        <h3 v-show="!HoneymoonDoubleRoom_switch">
          <router-link target="_blank" :to="{ name: 'Honeymoon' }">{{ Room_introduction }}</router-link>
        </h3>
      </div>

      <div class="AllStyle Duke">
        <h3 class="Room" :class="{ 'Click-Up': isDukeAddClass }" @click="Bus2">
          <a href="#">公爵雙人房</a>
        </h3>
        <h3 v-show="!DukeDoubleRoom_switch">
          <router-link target="_blank" :to="{ name: 'DukeDoubleRoom' }">{{ Room_introduction }}</router-link>
        </h3>
      </div>

      <div class="AllStyle Warm">
        <h3 class="Room" :class="{ 'Click-Up': isAddWarmClass }" @click="Bus2">
          <a href="#">溫馨雙人房</a>
        </h3>
        <h3 v-show="!CozydoubleRoom_switch">
          <router-link target="_blank" :to="{ name: 'CozyDoubleRoom' }">{{ Room_introduction }}</router-link>
        </h3>
      </div>

      <div class="AllStyle luxury">
        <h3 class="Room" :class="{ 'Click-Up': isAddluxuryClass }" @click="Bus2">
          <a href="#">豪華四人房</a>
        </h3>
        <h3 v-show="!DeluxeQuadrupleRoom_switch">
          <router-link target="_blank" :to="{ name: 'DeluxeQuadrupleRoom' }">{{ Room_introduction }}</router-link>
        </h3>
      </div>

      <div class="AllStyle VIP">
        <h3 class="Room" :class="{ 'Click-Up': isAddVIPClass }" @click="Bus2">
          <a href="#">VIP四人房</a>
        </h3>
        <h3 v-show="!VIPQuadrupleRoom_switch">
          <router-link target="_blank" :to="{ name: 'VIPQuadrupleRoom' }">{{ Room_introduction }}</router-link>
        </h3>
      </div>
    </div>

    <!-- For Phone -->

    <div class="PhoneRow">
      <v-carousel height="100vh" hide-delimiters show-arrows-on-hover hide-delimiter-background>
        <v-carousel-item class="PhoneBlock">
          <div class="textPosition">
            <h3>商務單人房</h3>
            <p>Business Single Room</p>
            <router-link target="_blank" :to="{ name: 'BusinessRoom' }">
              <v-btn rounded color="#F29100" dark large class="px-10">{{ Room_introduction }}</v-btn>
            </router-link>
          </div>
          <img :src="textupdate.photos[0]" />
        </v-carousel-item>
        <v-carousel-item class="PhoneBlock">
          <div class="textPosition">
            <h3>蜜月雙人房</h3>
            <p>Honeymoon Double Room</p>
            <router-link target="_blank" :to="{ name: 'Honeymoon' }">
              <v-btn rounded color="#F29100" dark large class="px-10">{{ Room_introduction }}</v-btn>
            </router-link>
          </div>
          <img :src="textupdate.photos[1]" />
        </v-carousel-item>
        <v-carousel-item class="PhoneBlock">
          <div class="textPosition">
            <h3>公爵雙人房</h3>
            <p>Duke Double Room</p>
            <router-link target="_blank" :to="{ name: 'DukeDoubleRoom' }">
              <v-btn rounded color="#F29100" dark large class="px-10">{{ Room_introduction }}</v-btn>
            </router-link>
          </div>
          <img :src="textupdate.photos[2]" />
        </v-carousel-item>
        <v-carousel-item class="PhoneBlock">
          <div class="textPosition">
            <h3>溫馨雙人房</h3>
            <p>Cozy double Room</p>
            <router-link target="_blank" :to="{ name: 'CozyDoubleRoom' }">
              <v-btn rounded color="#F29100" dark large class="px-10">{{ Room_introduction }}</v-btn>
            </router-link>
          </div>
          <img :src="textupdate.photos[3]" />
        </v-carousel-item>
        <v-carousel-item class="PhoneBlock">
          <div class="textPosition">
            <h3>豪華四人房</h3>
            <p>Deluxe Quadruple Room</p>
            <router-link target="_blank" :to="{ name: 'DeluxeQuadrupleRoom' }">
              <v-btn rounded color="#F29100" dark large class="px-10">{{ Room_introduction }}</v-btn>
            </router-link>
          </div>

          <img :src="textupdate.photos[4]" />
        </v-carousel-item>

        <v-carousel-item class="PhoneBlock">
          <div class="textPosition">
            <h3>VIP四人房</h3>
            <p>VIP Quadruple Room</p>
            <router-link target="_blank" :to="{ name: 'VIPQuadrupleRoom' }">
              <v-btn rounded color="#F29100" dark large class="px-10">{{ Room_introduction }}</v-btn>
            </router-link>
          </div>
          <img :src="textupdate.photos[5]" />
        </v-carousel-item>

        <template v-slot:prev="{ on, attrs }">
          <v-icon class="IconPosition" x-large v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-icon class="IconPosition" x-large v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
        </template>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/The_Sidebar.vue";
import FooterNav from "@/components/footer.vue";
import axios from 'axios';

export default {
  components: {
    sidebar,
    FooterNav,
  },

  data() {
    return {
      showMenu: false,
      ChangeButtonOpen: false,
      dialog: false,
      ErrorDialog: false,
      lineshow: false,

      direction: "top",
      fab: false,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: false,
      bottom: true,
      left: true,
      transition: "scale-transition",
      image: "",

      images: [],

      // click顯示圖片的data
      DisplayImagesBackground: "",

      //POST 參數
      textupdate: {
        photos: []
      },

      isAddClass: true, //預設的房型。
      isDenseAddClass: false,
      isDukeAddClass: false,
      isAddWarmClass: false,
      isAddluxuryClass: false,
      isAddVIPClass: false,

      BusinessSingleRoom_switch: false,
      HoneymoonDoubleRoom_switch: true,
      DukeDoubleRoom_switch: true,
      CozydoubleRoom_switch: true,
      DeluxeQuadrupleRoom_switch: true,
      VIPQuadrupleRoom_switch: true,

      Room_introduction: "房間介紹",
    };
  },
  mounted() {
    let vm = this;

    let config = {
      method: "post",
      url: "https://think-x-tech.synology.me/hotel_system/public/api/roomtypeIntro/show",
      headers: {
        Authorization: "Bearer 267|2cEoJMpGw63gFpsaK8crj6sy6kxPPmdQCCgtWKFF",
      },
    };

    axios(config)
      .then(function (response) {
        response.data.map((photo_data,) => {
          vm.textupdate.photos.push(
            'https://think-x-tech.synology.me/hotel_system/public/images/' + photo_data.path
          )
          vm.DisplayImagesBackground = vm.textupdate.photos[0];
        })
      })
      .catch(function (error) {
        console.log(error);
        console.log("created 失敗");
      });
  },
  methods: {
    Bus2(e) {
      let condition = e.target.innerText;
      let vm = this;
      switch (condition) {
        case "商務單人房":
          //class style
          vm.isAddClass = true;
          vm.isDenseAddClass = false;
          vm.isDukeAddClass = false;
          vm.isAddWarmClass = false;
          vm.isAddluxuryClass = false;
          vm.isAddVIPClass = false;

          //change room
          vm.BusinessSingleRoom_switch = false;
          vm.HoneymoonDoubleRoom_switch = true;
          vm.DukeDoubleRoom_switch = true;
          vm.CozydoubleRoom_switch = true;
          vm.DeluxeQuadrupleRoom_switch = true;
          vm.VIPQuadrupleRoom_switch = true;

          vm.DisplayImagesBackground = vm.textupdate.photo1;
          break;
        case "蜜月雙人房":
          //class style
          vm.isDenseAddClass = true;

          vm.isAddClass = false;
          vm.isDukeAddClass = false;
          vm.isAddWarmClass = false;
          vm.isAddluxuryClass = false;
          vm.isAddVIPClass = false;

          //change room
          vm.BusinessSingleRoom_switch = true;
          vm.HoneymoonDoubleRoom_switch = false;
          vm.DukeDoubleRoom_switch = true;
          vm.CozydoubleRoom_switch = true;
          vm.DeluxeQuadrupleRoom_switch = true;
          vm.VIPQuadrupleRoom_switch = true;
          //change room

          vm.DisplayImagesBackground = vm.textupdate.photo2;
          break;
        case "公爵雙人房":
          //class style
          vm.isDukeAddClass = true;

          vm.isAddWarmClass = false;
          vm.isAddClass = false;
          vm.isDenseAddClass = false;
          vm.isAddluxuryClass = false;
          vm.isAddVIPClass = false;

          //change room
          vm.BusinessSingleRoom_switch = true;
          vm.HoneymoonDoubleRoom_switch = true;
          vm.DukeDoubleRoom_switch = false;
          vm.CozydoubleRoom_switch = true;
          vm.DeluxeQuadrupleRoom_switch = true;
          vm.VIPQuadrupleRoom_switch = true;
          //change room
          vm.DisplayImagesBackground = vm.textupdate.photo3;
          break;
        case "溫馨雙人房":
          //class style
          vm.isAddWarmClass = true;

          vm.isDukeAddClass = false;
          vm.isAddClass = false;
          vm.isDenseAddClass = false;
          vm.isAddluxuryClass = false;
          vm.isAddVIPClass = false;

          //change room
          vm.BusinessSingleRoom_switch = true;
          vm.HoneymoonDoubleRoom_switch = true;
          vm.DukeDoubleRoom_switch = true;
          vm.CozydoubleRoom_switch = false;
          vm.DeluxeQuadrupleRoom_switch = true;
          vm.VIPQuadrupleRoom_switch = true;
          //change room
          vm.DisplayImagesBackground = vm.textupdate.photo4;
          break;
        case "豪華四人房":
          //class style
          vm.isAddluxuryClass = true;

          vm.isAddWarmClass = false;
          vm.isDukeAddClass = false;
          vm.isAddClass = false;
          vm.isDenseAddClass = false;
          vm.isAddVIPClass = false;

          //change room
          vm.BusinessSingleRoom_switch = true;
          vm.HoneymoonDoubleRoom_switch = true;
          vm.DukeDoubleRoom_switch = true;
          vm.CozydoubleRoom_switch = true;
          vm.DeluxeQuadrupleRoom_switch = false;
          vm.VIPQuadrupleRoom_switch = true;
          //change room

          vm.DisplayImagesBackground = vm.textupdate.photo5;
          break;
        case "VIP四人房":
          //class style
          vm.isAddVIPClass = true;

          vm.isAddWarmClass = false;
          vm.isDukeAddClass = false;
          vm.isAddClass = false;
          vm.isDenseAddClass = false;
          vm.isAddluxuryClass = false;

          //change room
          vm.BusinessSingleRoom_switch = true;
          vm.HoneymoonDoubleRoom_switch = true;
          vm.DukeDoubleRoom_switch = true;
          vm.CozydoubleRoom_switch = true;
          vm.DeluxeQuadrupleRoom_switch = true;
          vm.VIPQuadrupleRoom_switch = false;
          //change room
          vm.DisplayImagesBackground = this.textupdate.photo6;
          break;
      }
    },

    //登出時將 status 刪除
    Logout() {
      let vm = this;
      localStorage.removeItem("LoginStatus");
      localStorage.removeItem("Token");
      vm.$router.push({
        path: "/login",
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.SwitchBackground {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  transition: all 0.8s ease;
}

.backgroundImg {
  img {
    transition: all 1s ease-in-out;
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100vh;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .display_image {
    width: 100%;
    opacity: 1;
  }
  .hide_image {
    width: 0%;
  }
}
ul,
li {
  list-style-type: none;
}

.Room_image {
  // position: relative;
  img {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    transition: all 0.5s ease;
  }
}

.Room_Change_Option {
  display: flex;
  margin-top: 30%;
  a {
    color: white;
    position: relative;
    z-index: 3;
  }
  h3:hover {
    transform: scale(1.1);
    transition: all 0.5s;
  }
  a:hover {
    transition: all 0.5s;
    text-shadow: 0px 0px 6px rgb(255, 255, 255);
  }
  .AllStyle {
    border-top: 2px solid white;
    padding: 0 2%;
    text-align: center;
    position: relative;
  }
  .Room {
    position: relative;
    bottom: 0%;
    text-align: center;
    transition: all 0.8s ease;
  }
  .Click-Up {
    position: relative;
    bottom: 100%;
    text-align: center;
  }
  //每個房型的className
  .Room_item_but {
    position: relative;
    bottom: 0%;
    transition: all 0.5s ease;
  }

  .Room_item_Introduction_but {
    position: relative;
    bottom: 40%;
    left: 5%;
    // display: none;
    opacity: 0;
    transition: all 0.5s ease;
  }

  .Room_Change_List {
    display: flex;
  }

  //for Room Name go Top
  .item_go_top {
    position: relative;
    bottom: 100%;
  }

  //for Show Room_introduction
  .showItemStyle {
    opacity: 1;
  }

  hr {
    border: 0;
    height: 1px;
    background-color: white;
  }
}

.ChangeButton {
  position: fixed;
  bottom: 5%;
  left: 3%;
  display: flex;
  flex-direction: column;
}

#create .v-speed-dial {
  position: fixed;
}

#create .v-btn--floating {
  position: relative;
}

.level-line {
  position: relative;
  top: 47%;
  left: 20%;
  width: 60%;
  background-color: #9e9e9e57;
}

.straight-line {
  position: relative;
  top: 7%;
  left: 50%;
  height: 60%;
  background-color: #80808066;
}

.PhoneRow {
  display: none;
}

.Room-img-upload {
  display: flex;
  position: absolute;
  right: 20%;
  bottom: 2%;
}
.Room-img-upload label {
  margin: 0 3%;
}
@media screen and (min-width: 960px) and (max-width: 1264px) {
  .Room_Change_Option {
    margin-top: 50%;
    h3 {
      font-size: 25px;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 960px) {
  .Room_Change_Option {
    display: flex;
    flex-direction: column;
    margin: 20% 5%;
    border-radius: 20%;

    .AllStyle {
      border-top: 0px solid white;
      padding: 5% 0%;
      text-align: center;
      h3 {
        font-size: 25px;
        position: relative;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .PhoneRow {
    display: block;
  }
  .Room_Change_Option {
    display: none;
  }
  .PhoneBlock {
    img {
      object-fit: cover;
      width: 100%;
      height: 100vh;
    }
  }
  .textPosition {
    position: absolute;
    top: 20%;
    left: 10px;
    right: 0;
    bottom: 0;
    h3,
    p {
      color: white;
    }
    h3 {
      font-weight: 100;
      font-size: 35px;
    }
    p {
      letter-spacing: 6px;
      line-height: 2;
      margin-bottom: 15%;
    }
  }
}
</style>
